import $ from 'zepto';

import BaseField from './BaseField';

export default class Field extends BaseField {
  /**
  * @param {Zepto} field
  */
  constructor(baseClasses) {
    super(baseClasses);
    this.onClickPasswordIcon = this.onClickPasswordIcon.bind(this);
  }

  /**
   * initializes field and if is type password, it adds password
   * classes and events to field.
   *
   * @param {Zepto} $field
   */
  initField($field) {
    super.initField($field);
    if (this.isTypePassword()) {
      this.$field.addClass(this.passwordFieldClass);
      this.createPasswordIcon();
    }

    return this;
  }

  /**
   * determines if there is a value or not
   *
   * @returns {boolean}
   */
  isEmpty() {
    return !this.$control.val();
  }

  /**
   * determines if the field has a visible label
   *
   * @returns {boolean}
   */
  isLabelless() {
    return (
      this.$field.hasClass(this.labellessFieldClass)
      || this.$field.hasClass(this.smallFieldClass)
    );
  }

  /**
   * determines if the field has type password
   *
   * @returns {boolean}
   */
  isTypePassword() {
    return this.$control.attr('type') === 'password';
  }

  // #region creators
  /**
   * creates an button/icon and appends it to the field.
   * It adds necessary events to button.
   */
  createPasswordIcon() {
    this.$passwordIcon = $(`<button type="button" class="${this.passwordIconClass}" aria-hidden="true"/>`)
      .appendTo(this.$field)
      .click(this.onClickPasswordIcon);
  }
  // #endregion creators

  // #region actions
  /**
   * toggle type of input between text and password
   */
  togglePassword() {
    const type = this.$control.attr('type');
    if (type === 'password') {
      this.$control.attr('type', 'text');
    } else {
      this.$control.attr('type', 'password');
    }
  }
  // #endregion actions

  // #region event handlers
  onClickPasswordIcon() {
    this.$passwordIcon.toggleClass(`${this.passwordIconClass}-hide`);
    this.togglePassword();
  }
  // #endregion event handlers
}
